import React from 'react';
import {
    AlphaFeedBox,
    AlphafeedFullIcon,
} from '@/components/Hypertracker/HypertrackerSidebar/HypertrackerSidebarStyled';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { ROUTES } from '@/lib/constants/routes';
import { TFunction } from 'i18next';

interface AsideMenuAlphafeedItemProps {
    t: TFunction;
    closeMenu: () => void;
}

const AsideMenuAlphafeedItem: React.FC<AsideMenuAlphafeedItemProps> = ({ t, closeMenu }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const onClick = () => {
        navigate(ROUTES.HYPERTRACKER_ALPHAFEED);
        closeMenu();
    };

    return (
        <React.Fragment>
            <Typography
                data-testid="hypertracker-aside-menu-alphafeed-group-label"
                variant={'p12'}
                color={'customText.text1'}
                component={'p'}
                width={'100%'}
                sx={{
                    padding: '0 18px',
                    margin: '16px 0 4px',
                }}
            >
                {t('hypertracker_sidebar.group_trade')}
            </Typography>

            <AlphaFeedBox
                data-testid="hypertracker-aside-menu-alphafeed-item"
                role="button"
                onClick={onClick}
                sx={{
                    width: '92%',
                    backgroundColor: theme.palette.primitives.sun[500],
                    marginRight: '16px',
                }}
            >
                <AlphafeedFullIcon />
            </AlphaFeedBox>
        </React.Fragment>
    );
};

export default AsideMenuAlphafeedItem;
